import { SlidersHorizontal } from "lucide-react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";

export function TryPreferencesCard({ className }: PromotionalCardProps) {
	return (
		<PromotionalCardBase
			icon={<SlidersHorizontal className="w-full h-full" strokeWidth={1.5} />}
			title="Personalize Your Search"
			description="Set your preferences once & get AI-matched properties delivered to you"
			ctaText="Try Preferences"
			href="/preference-update"
			className={className}
			iconColor="text-violet-600"
		/>
	);
}
